import React from "react";

const DisplayReview = ({ review }) => {
  // Get client name from the backend response (Client.fullName)
  const userName = review.Client?.fullName || "Anonymous User";

  return (
    <div className="bg-white border border-gray-200 p-4 rounded-lg mb-4">
      <div className="flex items-center justify-between mb-2">
        <span className="font-medium text-gray-900">{userName}</span>
        <div className="flex space-x-1">
          {[...Array(5)].map((_, i) => (
            <span
              key={i}
              className={`text-lg ${
                i < review.rating ? "text-yellow-400" : "text-gray-300"
              }`}
            >
              ★
            </span>
          ))}
        </div>
      </div>
      
      {review.title && (
        <p className="text-gray-900 font-semibold mb-2">{review.title}</p>
      )}
      
      {review.comment && (
        <p className="text-gray-700 mb-2">{review.comment}</p>
      )}
      
      {review.createdAt && (
        <p className="text-xs text-gray-500">
          {new Date(review.createdAt).toLocaleDateString()}
        </p>
      )}
    </div>
  );
};

export default DisplayReview;
